<template>
  <div v-if="feed" class="feed-row" :class="`${deviceClass}`">
    <div class="actions-group mr-1">
      <PossibleActionButton
        v-for="event in feed.possible_events"
        :key="event"
        :event="event"
        @invoke="invoke"
      />
    </div>
    <div class="feed-actions ml-1">
      <el-tooltip
        class="item"
        effect="dark"
        placement="top-start"
        content="Edit"
      >
        <router-link :to="`/feeds/edit/${feed.id}`" title="Edit">
          <el-button
            type="success"
            plain
            circle
            size="small"
            icon="EditElementIcon"
            class="small-action-btn"
          />
        </router-link>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        placement="top-start"
        content="History"
      >
        <router-link :to="`/history/Feed/${feed.id}`">
          <el-button
            type="info"
            plain
            circle
            size="small"
            icon="TimerElementIcon"
            class="small-action-btn"
          />
        </router-link>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        placement="top-start"
        content="Clone feed"
      >
        <router-link :to="`/feeds/clone/${feed.id}`" title="Clone">
          <el-button
            type="primary"
            plain
            circle
            size="small"
            icon="CopyDocumentElementIcon"
            class="small-action-btn"
          />
        </router-link>
      </el-tooltip>
      <el-tooltip
        v-if="showDelete"
        class="item"
        effect="dark"
        placement="top-start"
        content="Mass enable"
      >
        <el-popconfirm
          confirm-button-text="OK"
          cancel-button-text="No, Thanks"
          confirm-button-type="primary"
          icon="InfoFilledElementIcon"
          icon-color="var(--el-color-primary)"
          :title="`Are you sure to mass enable '${feed.name}'?`"
          @confirm="onMassEnable"
        >
          <template #reference>
            <el-button
              type="primary"
              plain
              circle
              size="small"
              icon="CheckElementIcon"
              class="small-action-btn"
            />
          </template>
        </el-popconfirm>
      </el-tooltip>
      <el-tooltip
        v-if="showDelete"
        class="item"
        effect="dark"
        placement="top-start"
        content="Delete"
      >
        <el-popconfirm
          confirm-button-text="OK"
          cancel-button-text="No, Thanks"
          confirm-button-type="danger"
          icon="InfoFilledElementIcon"
          icon-color="red"
          :title="`Are you sure to delete '${feed.name}'?`"
          @confirm="onDelete"
        >
          <template #reference>
            <el-button
              type="danger"
              plain
              circle
              size="small"
              icon="DeleteElementIcon"
              class="small-action-btn"
            />
          </template>
        </el-popconfirm>
      </el-tooltip>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PossibleActionButton from '@/apps/traforama/components/PossibleActionButton.vue'
import { useFeedsStore } from '@/store/modules/feeds'
import { ElMessage } from 'element-plus'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'FeedActions',
  components: {
    PossibleActionButton
  },
  props: {
    feed: {
      type: Object,
      required: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const feedsStore = useFeedsStore()
    const { deviceClass } = useResize()

    const onDelete = () => {
      const feedId = props.feed.id.toString()
      feedsStore.DestroyItem(feedId).then(() => {
        ElMessage({
          message: 'Feed has been deleted',
          type: 'success'
        })
      })
    }

    const onMassEnable = () => {
      const feedId = props.feed.id.toString()
      feedsStore.MassEnable(feedId).then(() => {
        ElMessage({
          message: 'Mass enable started!',
          type: 'success'
        })
      })
    }

    const invoke = async (event: string) => {
      let result
      switch (event) {
        case 'destroy':
          result = await feedsStore.DestroyItem(props.feed.id)
          break
        default:
          result = await feedsStore.ChangeState(props.feed.id, event)
          ElMessage({
            message: 'Event has been successfully done!',
            type: 'success'
          })
      }
    }

    return { onDelete, onMassEnable, invoke, deviceClass }
  }
})
</script>

<style lang="scss" scoped>
.mr-1 {
  margin-right: 1em;
}
.feed-actions {
  display: table;
}

.actions-group {
  float: right;
}

.mobile .campaign-actions {
  display: flex;
  margin-top: 0.5em;
  justify-content: flex-end;
}

.small-action-btn {
  margin-right: 3px;
}

.feed-title {
  display: table;
  .mr-1 {
    margin-right: 1em;
  }
}

.feed-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid var(--el-border-color-light);
  &:last-child {
    border-bottom: none;
  }
  &.paused {
    .feed-name {
      color: var(--el-text-color-secondary);
    }
  }
}

.feed-title {
  display: flex;
}

.feed-id {
  color: var(--el-text-color-secondary);
  font-size: 10px;
}
.feed-name {
  font-size: 12px;
  line-height: 2;
}

@media (max-width: 550px) {
  .mobile .feed-title {
    flex-direction: column;
    display: flow-root;
    .feed-name {
      margin: 0.5em;
      padding-right: 0.1em;
    }
  }
  .mobile .feed-actions {
    flex-direction: column;
    margin-top: 0.5em;
    justify-content: flex-end;
    .el-button-group {
      margin-bottom: 0.5em;
    }
  }
  .feed-row {
    &.mobile {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
